import { Typography, Tooltip,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Category } from '@mui/icons-material';
import { thSx, tdSx, scoreColor } from './constants';
import { Card, CardTitle, ScoreBar } from './primitives';

const SectorBreakdown = ({ summary, sn: _sn, t }) => {
  if (!summary?.sectors?.length) return null;
  return (
    <Card sx={{ mb: 3 }}>
      <CardTitle icon={Category}>
        {t('stockStrength.sections.sectorBreakdown', { count: summary.sectors.length })}
      </CardTitle>
      <TableContainer sx={{ maxHeight: 400 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={thSx}>#</TableCell>
              <TableCell sx={thSx}>{t('stockStrength.table.sector')}</TableCell>
              <TableCell sx={thSx} align="center">{t('stockStrength.table.avgScore')}</TableCell>
              <TableCell sx={thSx} align="center">{t('stockStrength.table.count')}</TableCell>
              <TableCell sx={thSx} align="center">{t('stockStrength.table.leaders')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {summary.sectors.map((sec, i) => (
              <TableRow key={sec.sector} sx={{
                '&:hover': { bgcolor: alpha('#3b82f6', 0.04) },
                transition: 'background 0.15s',
              }}>
                <TableCell sx={tdSx}>
                  <Typography sx={{ fontSize: '0.7rem', fontWeight: 600, color: '#94a3b8' }}>{i + 1}</Typography>
                </TableCell>
                <TableCell sx={tdSx}>
                  <Tooltip title={sec.name_en || sec.sector}>
                    <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#1e293b' }}>
                      {sec.name_vi || sec.sector}
                    </Typography>
                  </Tooltip>
                </TableCell>
                <TableCell sx={tdSx} align="center">
                  <ScoreBar value={sec.avg_strength} color={scoreColor(sec.avg_strength_level_key)} />
                </TableCell>
                <TableCell sx={tdSx} align="center">
                  <Typography sx={{ fontSize: '0.72rem', fontWeight: 600, color: '#64748b' }}>{sec.count}</Typography>
                </TableCell>
                <TableCell sx={tdSx} align="center">
                  {sec.leaders > 0 && (
                    <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, color: '#10b981' }}>{sec.leaders}</Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
};

export default SectorBreakdown;
